import React, { useEffect, useState } from 'react'
import NewNavBar from "../../components/NewNavBar/NewNavBar";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import CustomSpinner from "../../components/CustomeSpinner/CustomeSpinner";
import Footer from "../../components/Footer/Footer";
import { Backdrop } from "@mui/material";
import { Star } from '@mui/icons-material';
import './CancellationPolicy.css';

const CancellationPolicy = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])
    const policies = [
        {
            id: 1,
            title: "Free Cancellation (Up to 24 Hours Before)",
            subPolicies: [
                "Customers can cancel their booking up to 24 hours before the scheduled service without incurring any charges.",
                "No hidden charges will be applied during this period."
            ],
        },
        {
            id: 2,
            title: "50% Refund (Within 12-24 Hours)",
            subPolicies: [
                "Cancellations made between 12 to 24 hours before the scheduled service are eligible for a 50% refund.",
                "Processing charges may apply."
            ],
        },
        {
            id: 3,
            title: "No Refund (Less Than 12 Hours)",
            subPolicies: [
                "Cancellations made less than 12 hours before the scheduled service are not eligible for any refund.",
                "Consider rescheduling instead of cancellation."
            ],
        },
        {
            id: 4,
            title: "Special Conditions",
            subPolicies: [
                "In cases of emergencies or unforeseen events, the company reserves the right to make exceptions on a case-by-case basis.",
                "Supporting documents may be required."
            ],
        },
    ];

    return (
        <>
            {isLoading && (
                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        backdropFilter: "blur(5px)",
                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                    }}
                    open={isLoading}
                >
                    <CustomSpinner color="inherit" />
                </Backdrop>
            )}
            <div className="stickyheader">
                <Header />
                <NewNavBar className="newnavbartoggle" />
            </div>
            <Sidebar className="sidebartoggle" />
            <main className="p-6 md:ml-64 bg-gray-50 min-h-screen">
                <div className='container mb-5'>
                    <div className="about-header">
                        <div className="header-content">
                            <div className="header-icon">
                                <Star style={{ fontSize: 48 }} />
                            </div>
                            <div className="header-text">
                                <h1>Cancellation Policy</h1>
                                {/* <p className="header-description">
                                                        We create joyful travel experiences with research-driven itineraries, reliable service, and all-inclusive value. Get to know the people, processes, and passion behind our journeys.
                                                    </p> */}
                            </div>
                        </div>
                    </div>
                    {/* <h1 className="text-3xl font-bold mb-6 text-gray-800 mt-2" style={{ color: 'black' }}>
                        Cancellation Policy
                    </h1> */}

                    <div className="space-y-4" >
                        {policies.map((policy) => (
                            <div key={policy.id} className="bg-white p-3 rounded-2xl shadow mt-1 mb-2" style={{ borderRadius: '15px' }}>
                                <h5 className="text-xl font-semibold mb-2">{policy.title}</h5>
                                <ul className="list-disc pl-6 text-gray-600">
                                    {policy.subPolicies.map((sub, idx) => (
                                        <li key={idx}>{sub}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default CancellationPolicy;
